import { render, staticRenderFns } from "./GeneralSection.vue?vue&type=template&id=13408a2e&scoped=true"
import script from "./GeneralSection.ts?vue&type=script&lang=ts&external"
export * from "./GeneralSection.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13408a2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13408a2e')) {
      api.createRecord('13408a2e', component.options)
    } else {
      api.reload('13408a2e', component.options)
    }
    module.hot.accept("./GeneralSection.vue?vue&type=template&id=13408a2e&scoped=true", function () {
      api.rerender('13408a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/tabs/GeneralTab/GeneralSection/GeneralSection.vue"
export default component.exports